export default __webpack_public_path__ + "static/media/Communication.5a4b45b0.png";